(function () {
  'use strict';
  function initialize(root) {
    if (root.dataset.hbReady) return;
    root.dataset.hbReady = 'true';
    var minimum = 4;
    var shippingThreshold = 7500;
    var busy = false;
    var expanded = false;
    var cards = Array.from(root.querySelectorAll('[data-hb-bag]'));
    var amounts = new Map(cards.map(function (card) { return [card.dataset.variant, 0]; }));
    var currency = root.dataset.currency || 'USD';
    var moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });
    function money(cents) { return moneyFormatter.format(cents / 100); }
    function find(selector) { return root.querySelector(selector); }
    var addButton = find('[data-hb-add]');
    var feedback = find('[data-hb-feedback]');
    var toggle = find('[data-hb-summary-toggle]');
    var selection = find('[data-hb-selection]');
    var desktop = window.matchMedia('(min-width: 1024px)');
    var header = document.getElementById('headerContainer');
    var geometryFrame = 0;
    var disposed = false;
    function setGeometryProperty(name, value) {
      if (root.style.getPropertyValue(name) !== value) root.style.setProperty(name, value);
    }
    function updateMobileGeometry() {
      geometryFrame = 0;
      if (disposed || desktop.matches) return;
      // iOS Safari's visual viewport can be shorter than the fixed-position layout viewport.
      var viewport = window.visualViewport;
      var height = viewport ? viewport.height : window.innerHeight;
      var viewportTop = viewport ? viewport.offsetTop : 0;
      var bottomInset = Math.max(0, window.innerHeight - height - viewportTop);
      var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var coveredTop = Math.max(0, headerBottom - viewportTop);
      setGeometryProperty('--hb-builder-header-bottom', Math.ceil(headerBottom) + 'px');
      setGeometryProperty('--hb-builder-viewport-height', Math.floor(height) + 'px');
      setGeometryProperty('--hb-builder-viewport-bottom', Math.ceil(bottomInset) + 'px');
      // Leave room for the counter above the panel. A large menu must not consume the purchase area.
      setGeometryProperty('--hb-builder-summary-top-clearance', Math.ceil(Math.min(coveredTop, height / 3) + 28) + 'px');
    }
    function scheduleGeometry() {
      if (!geometryFrame && !disposed) geometryFrame = window.requestAnimationFrame(updateMobileGeometry);
    }
    window.addEventListener('resize', scheduleGeometry, { passive: true });
    window.addEventListener('scroll', scheduleGeometry, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleGeometry, { passive: true });
      window.visualViewport.addEventListener('scroll', scheduleGeometry, { passive: true });
    }
    var geometryObserver = window.ResizeObserver ? new window.ResizeObserver(scheduleGeometry) : null;
    if (geometryObserver && header) geometryObserver.observe(header);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleGeometry);
    function disposeGeometry(event) {
      if (!event.target.contains(root)) return;
      disposed = true;
      window.cancelAnimationFrame(geometryFrame);
      window.removeEventListener('resize', scheduleGeometry);
      window.removeEventListener('scroll', scheduleGeometry);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', scheduleGeometry);
        window.visualViewport.removeEventListener('scroll', scheduleGeometry);
      }
      if (geometryObserver) geometryObserver.disconnect();
      document.removeEventListener('shopify:section:unload', disposeGeometry);
    }
    document.addEventListener('shopify:section:unload', disposeGeometry);
    updateMobileGeometry();

    function escape(value) { return String(value).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function setExpanded(value, restoreFocus) {
      expanded = value;
      toggle.setAttribute('aria-expanded', String(expanded));
      find('[data-hb-summary]').classList.toggle('is-expanded', expanded);
      render();
      if (restoreFocus) toggle.focus();
    }
    function getState() {
      var count = 0;
      var original = 0;
      var lines = [];
      cards.forEach(function (card) {
        var quantity = amounts.get(card.dataset.variant);
        if (!quantity) return;
        count += quantity;
        original += Number(card.dataset.price) * quantity;
        lines.push({ id: Number(card.dataset.variant), quantity: quantity, price: Number(card.dataset.price), title: card.dataset.title, image: card.querySelector('img') ? card.querySelector('img').currentSrc || card.querySelector('img').src : '' });
      });
      // Match the verified Shopify Function: floor the discount in minor units per bag, then multiply.
      var savings = count >= minimum ? lines.reduce(function (total, line) { return total + Math.floor(line.price * .15) * line.quantity; }, 0) : 0;
      return { count: count, original: original, savings: savings, total: original - savings, lines: lines };
    }
    function progress(element, value, max) {
      element.setAttribute('aria-valuenow', String(Math.min(value, max)));
      element.querySelector('span').style.width = Math.min(100, value / max * 100) + '%';
    }
    function render() {
      var state = getState();
      var left = Math.max(0, minimum - state.count);
      selection.hidden = !desktop.matches && !expanded;
      find('[data-hb-selected-list]').hidden = desktop.matches;
      find('[data-hb-slots]').hidden = !desktop.matches;
      find('[data-hb-selection-count]').hidden = !desktop.matches;
      find('[data-hb-selection-count]').textContent = state.count + (left ? ' of 4' : '') + ' bags selected';
      cards.forEach(function (card) {
        var amount = amounts.get(card.dataset.variant);
        var output = card.querySelector('[data-hb-quantity]');
        if (output) output.textContent = amount;
        var minus = card.querySelector('[data-hb-minus]');
        var plus = card.querySelector('[data-hb-plus]');
        if (minus) minus.disabled = busy || amount === 0;
        if (plus) plus.disabled = busy;
        card.classList.toggle('is-selected', amount > 0);
      });
      find('[data-hb-count]').textContent = state.count;
      toggle.setAttribute('aria-label', (expanded ? 'Hide' : 'Show') + ' selection, ' + state.count + (state.count === 1 ? ' bag' : ' bags'));
      find('[data-hb-minimum]').textContent = left ? 'Add ' + left + ' more ' + (left === 1 ? 'bag' : 'bags') + ' to save 15%' : 'Success! Your 15% discount is applied.';
      find('[data-hb-original]').textContent = money(state.original);
      find('[data-hb-original]').hidden = !state.savings;
      find('[data-hb-total]').textContent = money(state.total);
      find('[data-hb-purchase]').hidden = !desktop.matches && !expanded && left > 0;
      find('[data-hb-selection-empty]').hidden = state.count > 0;
      var active = document.activeElement;
      var activeVariant = active && active.dataset && active.dataset.hbSelectedVariant;
      var activeStep = active && active.dataset && active.dataset.hbSelectionStep;
      find('[data-hb-slots]').innerHTML = state.lines.map(function (line) {
        return '<li class="hb-builder__slot" title="' + escape(line.title) + ' · ' + line.quantity + (line.quantity === 1 ? ' bag' : ' bags') + '">' + (line.image ? '<img src="' + escape(line.image) + '" alt="' + escape(line.title) + '" width="80" height="80">' : '<span>' + escape(line.title) + '</span>') + '<span class="hb-builder__slot-count">×' + line.quantity + '</span><button type="button" data-hb-selected-variant="' + line.id + '" data-hb-selection-step="-1" aria-label="Remove one ' + escape(line.title) + ' bag"' + (busy ? ' disabled' : '') + '>×</button></li>';
      }).join('') + Array.from({ length: left }, function () { return '<li class="hb-builder__slot hb-builder__slot--empty" aria-hidden="true"><span>+</span></li>'; }).join('');
      find('[data-hb-selected-list]').innerHTML = state.lines.map(function (line) {
        var unitPrice = line.price - (state.count >= minimum ? Math.floor(line.price * .15) : 0);
        return '<li class="hb-builder__selected-item">' + (line.image ? '<img src="' + escape(line.image) + '" alt="" width="48" height="48">' : '<span></span>') + '<div class="hb-builder__selected-name"><strong>' + escape(line.title) + '</strong><span>' + money(unitPrice * line.quantity) + '</span></div><div class="hb-builder__selected-quantity"><button type="button" data-hb-selected-variant="' + line.id + '" data-hb-selection-step="-1" aria-label="Remove one ' + escape(line.title) + ' bag"' + (busy ? ' disabled' : '') + '>−</button><output aria-label="' + escape(line.title) + ' bags selected">' + line.quantity + '</output><button type="button" data-hb-selected-variant="' + line.id + '" data-hb-selection-step="1" aria-label="Add one ' + escape(line.title) + ' bag"' + (busy ? ' disabled' : '') + '>+</button></div></li>';
      }).join('');
      if (activeVariant) {
        var visibleList = desktop.matches ? find('[data-hb-slots]') : find('[data-hb-selected-list]');
        var replacement = visibleList.querySelector('[data-hb-selected-variant="' + activeVariant + '"][data-hb-selection-step="' + activeStep + '"]');
        var sourceCard = cards.find(function (card) { return card.dataset.variant === activeVariant; });
        (replacement || (desktop.matches && sourceCard ? sourceCard.querySelector('[data-hb-plus]') : toggle)).focus({ preventScroll: true });
      }
      var bagMessage = find('[data-hb-bag-message]');
      bagMessage.querySelector('strong').textContent = left ? state.count + ' of 4 bags' : state.count + ' bags · 15% unlocked';
      bagMessage.querySelector('span').textContent = left ? 'Add ' + left + ' more ' + (left === 1 ? 'bag' : 'bags') + ' to save 15%' : 'Keep going. There is no maximum.';
      var shippingMessage = find('[data-hb-shipping-message]');
      shippingMessage.querySelector('strong').textContent = state.total >= shippingThreshold ? 'Free shipping unlocked' : money(shippingThreshold - state.total) + ' to free shipping';
      progress(find('[data-hb-bag-progress]'), state.count, minimum);
      progress(find('[data-hb-shipping-progress]'), state.total, shippingThreshold);
      addButton.disabled = busy || left > 0;
      addButton.textContent = busy ? 'Adding your box…' : left ? 'Add ' + left + ' more ' + (left === 1 ? 'bag' : 'bags') : 'Add your box · ' + money(state.total);
    }
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !desktop.matches && expanded && find('[data-hb-summary]').contains(event.target)) { event.preventDefault(); setExpanded(false, true); }
    });
    root.addEventListener('click', async function (event) {
      if (event.target.closest('[data-hb-summary-toggle]')) { setExpanded(!expanded, false); return; }
      var selectionButton = event.target.closest('[data-hb-selection-step]');
      if (selectionButton) {
        if (busy || selectionButton.disabled) return;
        var selectedId = selectionButton.dataset.hbSelectedVariant;
        if (!amounts.has(selectedId)) return;
        amounts.set(selectedId, Math.max(0, amounts.get(selectedId) + Number(selectionButton.dataset.hbSelectionStep)));
        feedback.textContent = ''; render(); return;
      }
      var quantityButton = event.target.closest('[data-hb-plus],[data-hb-minus]');
      if (quantityButton) {
        if (busy || quantityButton.disabled) return;
        var card = quantityButton.closest('[data-hb-bag]');
        if (!card || card.dataset.available !== 'true') return;
        var current = amounts.get(card.dataset.variant);
        amounts.set(card.dataset.variant, Math.max(0, current + (quantityButton.hasAttribute('data-hb-plus') ? 1 : -1)));
        feedback.textContent = '';
        render();
        return;
      }
      if (!event.target.closest('[data-hb-add]') || busy) return;
      var state = getState();
      if (state.count < minimum) {
        feedback.textContent = 'Choose at least 4 bags to add your box.';
        return;
      }
      busy = true;
      addButton.setAttribute('aria-busy', 'true');
      feedback.textContent = '';
      render();
      try {
        if (typeof window.HBBoxCart?.add !== 'function') throw new Error('The cart is still loading. Please try again.');
        await window.HBBoxCart.add({ items: state.lines.map(function (line) {
          return { id: line.id, quantity: line.quantity, properties: { _hb_box: '20260929', Box: 'Build Your Own Box' } };
        }) }, addButton);
        amounts.forEach(function (_, id) { amounts.set(id, 0); });
        expanded = false; selection.hidden = true; toggle.setAttribute('aria-expanded', 'false'); find('[data-hb-summary]').classList.toggle('is-expanded', false);
        feedback.textContent = 'Your box has been added to the cart.';
      } catch (error) {
        feedback.textContent = error.message || 'We could not add your box. Please try again. Your selection is saved here.';
      } finally {
        busy = false;
        addButton.removeAttribute('aria-busy');
        render();
      }
    });
    desktop.addEventListener('change', function () {
      scheduleGeometry();
      var active = document.activeElement;
      if (!desktop.matches && selection.contains(active)) expanded = true;
      toggle.setAttribute('aria-expanded', String(expanded));
      render();
      if (desktop.matches && active === toggle && cards.length) cards[0].querySelector('[data-hb-plus]')?.focus({ preventScroll: true });
    });
    render();
  }
  function boot(scope) { scope.querySelectorAll('[data-hb-builder]').forEach(initialize); }
  boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
